// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/**
 * Shared content pages (Resources, Events, Podcasts, etc.) — matches homepage/collective.
 */
.twentytwentysix-content {
  --ac-cream: #efe4d3;
  --ac-light: #f5f3f1;
  --ac-teal: #6f9f9a;
  --ac-coral: #df775f;
  --ac-gold: #d8b04e;
  --ac-charcoal: #4b4450;
  --ac-text: #433d43;
  --ac-muted: #6b666b;
  --ac-white: #ffffff;
  --ac-shadow: 0 10px 30px rgba(0, 0, 0, 0.08);
  --ac-radius: 20px;
  --ac-font-display: "fabulosa", sans-serif;

  min-height: 50vh;
  background: var(--ac-light);
  color: var(--ac-text);
  font-family: Arial, Helvetica, sans-serif;
}

.twentytwentysix-content__container {
  /* Responsive content container
     - Desktop: cap content width at 1080px with generous gutters
     - Tablet: slightly tighter gutters
     - Mobile: full-width with safe side padding
     This is the standard content-width system for twentytwentysix pages.
  */
  --twentytwentysix-container-max: 1080px;
  width: min(var(--twentytwentysix-container-max), calc(100% - 48px));
  margin: 0 auto;
  padding: 48px 0 64px;
}

@media (max-width: 900px) {
  .twentytwentysix-content__container {
    width: min(var(--twentytwentysix-container-max), calc(100% - 32px));
  }
}

@media (max-width: 600px) {
  .twentytwentysix-content__container {
    width: min(var(--twentytwentysix-container-max), calc(100% - 24px));
  }
}

.twentytwentysix-content__section {
  padding: 40px 0;
}

.twentytwentysix-content__section--cream {
  background: var(--ac-cream);
}

.twentytwentysix-content__section--charcoal {
  background: var(--ac-charcoal);
  color: var(--ac-white);
}

.twentytwentysix-content__section--charcoal .twentytwentysix-content__copy {
  color: rgba(255, 255, 255, 0.9);
}

.twentytwentysix-content__eyebrow {
  font-size: 0.9rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.2em;
  color: var(--ac-muted);
  margin: 0 0 12px;
}

.twentytwentysix-content__title {
  font-family: var(--ac-font-display);
  font-weight: 400;
  font-size: clamp(2rem, 4vw, 3rem);
  color: var(--ac-teal);
  margin: 0 0 16px;
  line-height: 1.1;
}

.twentytwentysix-content__section--charcoal .twentytwentysix-content__title {
  color: var(--ac-white);
}

.twentytwentysix-content__copy {
  font-size: 1.05rem;
  line-height: 1.65;
  color: var(--ac-text);
  margin: 0 0 16px;
  max-width: 720px;
}

.twentytwentysix-content__subtitle {
  font-size: 1.1rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.12em;
  margin: 28px 0 12px;
}

.twentytwentysix-content__list {
  list-style: none;
  padding: 0;
  margin: 0 0 24px;
}

.twentytwentysix-content__list li {
  position: relative;
  padding-left: 24px;
  margin: 10px 0;
  line-height: 1.5;
}

.twentytwentysix-content__list li::before {
  content: "•";
  position: absolute;
  left: 0;
  color: var(--ac-teal);
  font-weight: 700;
}

.twentytwentysix-content__card-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));
  gap: 24px;
  margin-top: 24px;
}

.twentytwentysix-content__card {
  background: var(--ac-white);
  border-radius: var(--ac-radius);
  padding: 24px;
  box-shadow: var(--ac-shadow);
}

.twentytwentysix-content__card h4 {
  font-family: var(--ac-font-display);
  font-weight: 400;
  font-size: 1.4rem;
  margin: 0 0 10px;
  color: var(--ac-teal);
}

.twentytwentysix-content__card p {
  margin: 0;
  font-size: 0.98rem;
  line-height: 1.5;
  color: var(--ac-muted);
}

.twentytwentysix-content__pill {
  display: inline-block;
  padding: 12px 24px;
  border-radius: 999px;
  background: var(--ac-gold);
  color: var(--ac-white);
  font-weight: 700;
  text-decoration: none;
  border: none;
  cursor: pointer;
  font-size: 1rem;
  box-shadow: var(--ac-shadow);
  transition: transform 0.2s ease, box-shadow 0.2s ease;
}

.twentytwentysix-content__pill:hover {
  transform: translateY(-2px);
  box-shadow: 0 14px 40px rgba(0, 0, 0, 0.12);
}

.twentytwentysix-content__pill--outline {
  background: transparent;
  color: var(--ac-teal);
  border: 2px solid var(--ac-teal);
}

.twentytwentysix-content__link {
  color: var(--ac-teal);
  font-weight: 600;
  text-decoration: none;
}

.twentytwentysix-content__link:hover {
  text-decoration: underline;
}

.twentytwentysix-content__cta-row {
  margin-top: 28px;
  display: flex;
  flex-wrap: wrap;
  gap: 14px;
}

/* Filter bar: search and filter controls (Events, M List) */
.twentytwentysix-content__filter-bar {
  padding-top: 16px;
  padding-bottom: 24px;
}

.twentytwentysix-content__search-form {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 12px;
}

.twentytwentysix-content__filter-input {
  flex: 1 1;
  min-width: 200px;
  padding: 10px 16px;
  border: 2px solid var(--ac-teal);
  border-radius: 999px;
  font-size: 1rem;
  color: var(--ac-text);
  background: var(--ac-white);
}

.twentytwentysix-content__filter-input::placeholder {
  color: var(--ac-muted);
}

.twentytwentysix-content__filter-input:focus {
  outline: none;
  box-shadow: 0 0 0 3px rgba(111, 159, 154, 0.25);
}

.twentytwentysix-content__pill--small {
  padding: 8px 18px;
  font-size: 0.95rem;
}

.twentytwentysix-content__event-item {
  margin-bottom: 16px;
  padding-bottom: 16px;
  border-bottom: 1px solid var(--ac-border, #e0e0e0);
}

.twentytwentysix-content__event-item:last-child {
  border-bottom: none;
}

.twentytwentysix-content__event-meta {
  display: block;
  font-size: 0.9rem;
  color: var(--ac-muted);
}

.twentytwentysix-content__event-desc {
  margin: 8px 0 0;
  font-size: 0.95rem;
}

.twentytwentysix-content__filter-pills {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin-bottom: 16px;
}

.twentytwentysix-content__filter-pill {
  display: inline-block;
  padding: 6px 14px;
  border-radius: 999px;
  font-size: 0.9rem;
  font-weight: 600;
  text-decoration: none;
  border: 2px solid var(--ac-teal);
  color: var(--ac-teal);
  background: transparent;
  cursor: pointer;
  transition: background 0.2s ease, color 0.2s ease;
}

.twentytwentysix-content__filter-pill:hover {
  background: rgba(111, 159, 154, 0.1);
}

.twentytwentysix-content__filter-pill--active {
  background: var(--ac-teal);
  color: var(--ac-white);
  border-color: var(--ac-teal);
}

.twentytwentysix-content__filter-pills-wrap {
  margin-top: 12px;
}

.twentytwentysix-content__filter-label {
  display: block;
  font-size: 0.85rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.08em;
  color: var(--ac-muted);
  margin-bottom: 8px;
}

.twentytwentysix-content__list--no-bullets li::before {
  content: none;
}

.twentytwentysix-content__list--no-bullets {
  padding-left: 0;
}

.twentytwentysix-content__listing-item {
  margin-bottom: 12px;
  padding-bottom: 12px;
  border-bottom: 1px solid var(--ac-border, #e0e0e0);
}

.twentytwentysix-content__listing-item:last-child {
  border-bottom: none;
}

.twentytwentysix-content__listing-desc {
  display: block;
  color: var(--ac-muted);
  font-size: 0.95rem;
  margin: 6px 0 0;
}

.twentytwentysix-content__listing-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));
  gap: 24px;
}

.twentytwentysix-content__listing-card {
  background: var(--ac-white);
  border-radius: var(--ac-radius);
  box-shadow: var(--ac-shadow);
  overflow: hidden;
  margin-bottom: 0;
  padding-bottom: 0;
  border-bottom: none;
}

.twentytwentysix-content__listing-card-inner {
  display: block;
  width: 100%;
  padding: 0;
  margin: 0;
  border: none;
  background: none;
  cursor: pointer;
  text-align: left;
  font: inherit;
  color: inherit;
}

.twentytwentysix-content__listing-card-inner:focus {
  outline: 2px solid var(--ac-teal);
  outline-offset: 2px;
}

.twentytwentysix-content__listing-image-wrap {
  position: relative;
  width: 100%;
  aspect-ratio: 1 / 1;
  overflow: hidden;
  background: var(--ac-light);
}

.twentytwentysix-content__listing-image-media {
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  overflow: hidden;
}

.twentytwentysix-content__listing-image {
  display: block;
  width: calc(100% + 48px);
  height: calc(100% + 48px);
  max-width: none;
  max-height: none;
  margin-top: -24px;
  margin-left: -40px;
  object-fit: cover;
  object-position: center center;
}

.twentytwentysix-content__listing-image-placeholder {
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  background: var(--ac-light);
}

.twentytwentysix-content__listing-body {
  padding: 16px;
}

.twentytwentysix-content__listing-name {
  display: block;
  font-size: 1.1rem;
  color: var(--ac-teal);
}

.twentytwentysix-content__listing-hearts {
  display: inline-block;
  font-size: 0.85rem;
  color: var(--ac-coral);
  margin-top: 4px;
}

.twentytwentysix-content__listing-tags {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
  margin-top: 10px;
}

.twentytwentysix-content__listing-tag {
  font-size: 0.8rem;
  padding: 4px 10px;
  border-radius: 999px;
  background: var(--ac-light);
  color: var(--ac-muted);
}

.twentytwentysix-content__listing-meta {
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
  margin-top: 10px;
  font-size: 0.9rem;
}

.twentytwentysix-content__listing-phone {
  color: var(--ac-muted);
}

/* Listing detail modal — twentytwentysix design language */
.twentytwentysix-content__listing-detail-overlay {
  position: fixed;
  inset: 0;
  z-index: 10000;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 24px;
  background: rgba(0, 0, 0, 0.4);
  overflow-y: auto;
}

.twentytwentysix-content__listing-detail-modal {
  position: relative;
  width: 100%;
  max-width: 720px;
  max-height: calc(100vh - 48px);
  overflow-y: auto;
  background: var(--ac-white);
  border-radius: var(--ac-radius);
  box-shadow: var(--ac-shadow);
  padding: 28px 24px 24px;
}

.twentytwentysix-content__listing-detail-close {
  position: absolute;
  top: 12px;
  right: 12px;
  width: 36px;
  height: 36px;
  padding: 0;
  font-size: 1.5rem;
  line-height: 1;
  color: var(--ac-muted);
  background: none;
  border: none;
  cursor: pointer;
  border-radius: 50%;
}

.twentytwentysix-content__listing-detail-close:hover {
  color: var(--ac-text);
  background: var(--ac-light);
}

.twentytwentysix-content__listing-detail-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 28px;
  align-items: start;
}

@media (max-width: 640px) {
  .twentytwentysix-content__listing-detail-grid {
    grid-template-columns: 1fr;
  }
}

.twentytwentysix-content__listing-detail-content {
  min-width: 0;
}

.twentytwentysix-content__listing-detail-meta {
  font-size: 0.85rem;
  color: var(--ac-muted);
  margin: 0 0 8px;
  text-transform: uppercase;
  letter-spacing: 0.06em;
}

.twentytwentysix-content__listing-detail-title {
  font-family: var(--ac-font-display);
  font-weight: 400;
  font-size: 1.6rem;
  color: var(--ac-teal);
  margin: 0 0 10px;
  line-height: 1.2;
}

.twentytwentysix-content__listing-detail-subhead {
  font-size: 1rem;
  color: var(--ac-text);
  margin: 0 0 14px;
  line-height: 1.45;
}

.twentytwentysix-content__listing-detail-body {
  font-size: 0.98rem;
  line-height: 1.6;
  color: var(--ac-text);
  margin: 0 0 16px;
}

.twentytwentysix-content__listing-detail-body p {
  margin: 0 0 10px;
}

.twentytwentysix-content__listing-detail-body p:last-child {
  margin-bottom: 0;
}

.twentytwentysix-content__listing-detail-links {
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
  margin-bottom: 14px;
  font-size: 0.9rem;
}

.twentytwentysix-content__listing-detail-badges {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}

.twentytwentysix-content__listing-detail-image-wrap {
  position: relative;
  aspect-ratio: 1;
  width: 100%;
  max-width: 320px;
  justify-self: end;
  background: var(--ac-light);
  border-radius: var(--ac-radius);
  overflow: hidden;
}

@media (max-width: 640px) {
  .twentytwentysix-content__listing-detail-image-wrap {
    justify-self: center;
    max-width: 100%;
  }
}

.twentytwentysix-content__listing-detail-image {
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: center;
  display: block;
}

.twentytwentysix-content__listing-detail-image-placeholder {
  position: absolute;
  inset: 0;
  background: var(--ac-light);
}

.twentytwentysix-content__listing-detail-actions {
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
  margin-top: 24px;
  padding-top: 20px;
  border-top: 1px solid var(--ac-light);
}

.twentytwentysix-content__api-notice {
  background: rgba(111, 159, 154, 0.12);
  border: 1px solid var(--ac-teal);
  border-radius: 12px;
  padding: 16px 20px;
}

.twentytwentysix-content__api-notice-text code {
  background: var(--ac-white);
  padding: 2px 6px;
  border-radius: 4px;
  font-size: 0.9em;
}

.twentytwentysix-content__empty-listings {
  margin-bottom: 24px;
}

.twentytwentysix-content__copy--muted {
  font-size: 0.95rem;
  color: var(--ac-muted);
  margin-top: 8px;
}

/* M List: two-column layout (sidebar + main) — layout from legacy TheMList, styling from twentytwentysix */
.twentytwentysix-content__mlist-layout {
  display: grid;
  grid-template-columns: 260px 1fr;
  gap: 40px;
  align-items: start;
  margin-top: 32px;
}

.twentytwentysix-content__mlist-sidebar-col {
  min-width: 0;
}

@media (max-width: 768px) {
  .twentytwentysix-content__mlist-layout {
    grid-template-columns: 1fr;
  }
}

.twentytwentysix-content__mlist-sidebar {
  position: sticky;
  top: 24px;
  align-self: flex-start;
  max-height: calc(100vh - 48px);
  overflow-y: auto;
  background: var(--ac-white);
  border-radius: var(--ac-radius);
  padding: 24px;
  box-shadow: var(--ac-shadow);
}

.twentytwentysix-content__mlist-sidebar-title {
  font-size: 0.85rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.12em;
  color: var(--ac-muted);
  margin: 0 0 14px;
}

.twentytwentysix-content__mlist-sidebar-nav {
  list-style: none;
  padding: 0;
  margin: 0 0 20px;
}

.twentytwentysix-content__mlist-sidebar-nav li {
  padding-left: 0;
  margin: 0;
}

.twentytwentysix-content__mlist-sidebar-nav li::before {
  content: none;
}

.twentytwentysix-content__mlist-sidebar-nav button {
  display: block;
  width: 100%;
  text-align: left;
  padding: 10px 0;
  font-size: 0.95rem;
  color: var(--ac-text);
  background: none;
  border: none;
  cursor: pointer;
  border-bottom: 1px solid var(--ac-light);
  transition: color 0.2s ease;
}

.twentytwentysix-content__mlist-sidebar-nav button:last-child {
  border-bottom: none;
}

.twentytwentysix-content__mlist-sidebar-nav button:hover {
  color: var(--ac-teal);
}

.twentytwentysix-content__mlist-sidebar-nav button.twentytwentysix-content__mlist-sidebar-nav--active {
  color: var(--ac-teal);
  font-weight: 700;
}

.twentytwentysix-content__mlist-sidebar-featured {
  margin: 20px 0;
  padding-top: 20px;
  border-top: 1px solid var(--ac-light);
}

.twentytwentysix-content__mlist-sidebar-cta {
  margin-top: 24px;
  padding-top: 24px;
  border-top: 1px solid var(--ac-light);
}

.twentytwentysix-content__mlist-sidebar-cta .twentytwentysix-content__copy {
  margin-bottom: 14px;
  max-width: none;
}

.twentytwentysix-content__mlist-main {
  min-width: 0;
}

/* M List: top facet groups (value, badge, philanthropy) */
.twentytwentysix-content__mlist-top-filters {
  padding-bottom: 24px;
}

.twentytwentysix-content__mlist-clear-filters {
  margin-left: 8px;
}

.twentytwentysix-content__mlist-facets-row {
  display: flex;
  flex-wrap: wrap;
  gap: 24px 32px;
  margin-top: 20px;
}

.twentytwentysix-content__mlist-facet-group {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.twentytwentysix-content__mlist-facet-group-title {
  font-size: 0.85rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.08em;
  color: var(--ac-muted);
}

.twentytwentysix-content__mlist-facet-options {
  display: flex;
  flex-wrap: wrap;
  gap: 8px 16px;
}

.twentytwentysix-content__mlist-facet-option {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  cursor: pointer;
  font-size: 0.95rem;
  color: var(--ac-text);
}

.twentytwentysix-content__mlist-facet-option input {
  margin: 0;
}

/* M List: left sidebar expandable category groups */
.twentytwentysix-content__mlist-sidebar-groups {
  margin-bottom: 20px;
}

.twentytwentysix-content__mlist-sidebar-group {
  margin-bottom: 4px;
}

.twentytwentysix-content__mlist-sidebar-group-head {
  display: flex;
  align-items: center;
  gap: 6px;
  width: 100%;
  padding: 8px 0;
  font-size: 0.95rem;
  font-weight: 600;
  color: var(--ac-text);
  background: none;
  border: none;
  cursor: pointer;
  text-align: left;
}

.twentytwentysix-content__mlist-sidebar-group-head:hover {
  color: var(--ac-teal);
}

.twentytwentysix-content__mlist-sidebar-group-caret {
  font-size: 0.7rem;
  color: var(--ac-muted);
}

.twentytwentysix-content__mlist-sidebar-group-body {
  padding-left: 14px;
  margin-bottom: 8px;
}

.twentytwentysix-content__mlist-sidebar-check {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 6px 0;
  cursor: pointer;
  font-size: 0.9rem;
  color: var(--ac-text);
}

.twentytwentysix-content__mlist-sidebar-check input {
  margin: 0;
}

.twentytwentysix-content__mlist-sidebar-check:hover {
  color: var(--ac-teal);
}

.twentytwentysix-content__mlist-sidebar-clear {
  margin-bottom: 12px;
}

.twentytwentysix-content__mlist-sidebar-clear-categories {
  margin-bottom: 12px;
}

.twentytwentysix-content__mlist-sidebar-facet-group {
  margin-bottom: 20px;
}

.twentytwentysix-content__mlist-sidebar-facet-group .twentytwentysix-content__mlist-sidebar-title {
  margin-bottom: 10px;
}

.twentytwentysix-content__mlist-sidebar-facet-options {
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.twentytwentysix-content__mlist-results-header {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 16px;
  margin-bottom: 16px;
}

.twentytwentysix-content__mlist-featured-toggle {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  cursor: pointer;
  font-size: 0.95rem;
  color: var(--ac-text);
}

.twentytwentysix-content__mlist-featured-toggle input {
  margin: 0;
}

/* Events page: same layout rhythm as M List (no sidebar), same card/filter language */
.twentytwentysix-content__events-layout {
  margin-top: 32px;
}

.twentytwentysix-content__events-top-filters {
  padding-bottom: 24px;
}

.twentytwentysix-content__events-clear-filters {
  margin-left: 8px;
}

.twentytwentysix-content__events-results-header {
  margin-bottom: 16px;
}

.twentytwentysix-content__event-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));
  gap: 24px;
}

/* Event card: date tab overlapping top + square image-led card (title/CTA on image, copy below) */
.twentytwentysix-content__event-card {
  position: relative;
  background: var(--ac-white);
  border-radius: var(--ac-radius);
  box-shadow: var(--ac-shadow);
  overflow: visible;
  margin-bottom: 0;
  padding-bottom: 0;
  border-bottom: none;
}

.twentytwentysix-content__event-card-inner {
  display: block;
  width: 100%;
  overflow: hidden;
  border-radius: var(--ac-radius);
}

/* Date tab: overlaps top edge of card, month above day */
.twentytwentysix-content__event-date-tab {
  position: absolute;
  top: -6px;
  left: 16px;
  z-index: 2;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-width: 52px;
  padding: 6px 10px 8px;
  background: var(--ac-white);
  color: var(--ac-teal);
  border-radius: 10px;
  box-shadow: var(--ac-shadow);
  border: 2px solid var(--ac-teal);
}

.twentytwentysix-content__event-date-tab-month {
  display: block;
  font-size: 0.7rem;
  font-weight: 700;
  letter-spacing: 0.08em;
  line-height: 1.2;
}

.twentytwentysix-content__event-date-tab-day {
  display: block;
  font-size: 1.35rem;
  font-weight: 700;
  line-height: 1.1;
}

.twentytwentysix-content__event-image-wrap {
  position: relative;
  width: 100%;
  aspect-ratio: 1;
  overflow: hidden;
  background: var(--ac-light);
}

.twentytwentysix-content__event-image {
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: 58% 50%;
  display: block;
}

.twentytwentysix-content__event-image-placeholder {
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  background: var(--ac-light);
}

/* Overlay on image: gradient + title, event type pill, CTA button */
.twentytwentysix-content__event-image-overlay {
  position: absolute;
  inset: 0;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  padding: 20px 16px 16px;
  background: linear-gradient(to top, rgba(0, 0, 0, 0.65) 0%, rgba(0, 0, 0, 0.2) 45%, transparent 70%);
  pointer-events: none;
}

.twentytwentysix-content__event-image-overlay .twentytwentysix-content__event-card-cta-btn {
  pointer-events: auto;
}

.twentytwentysix-content__event-type-pill {
  align-self: flex-start;
  padding: 4px 10px;
  margin-bottom: 8px;
  font-size: 0.75rem;
  font-weight: 700;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  color: var(--ac-white);
  background: var(--ac-teal);
  border-radius: 999px;
}

.twentytwentysix-content__event-card-title {
  font-family: var(--ac-font-display);
  font-weight: 400;
  font-size: 1.25rem;
  line-height: 1.2;
  color: var(--ac-white);
  margin: 0 0 10px;
  text-shadow: 0 1px 3px rgba(0, 0, 0, 0.4);
}

.twentytwentysix-content__event-card-cta-btn {
  align-self: flex-start;
  display: inline-block;
  padding: 10px 20px;
  font-size: 0.95rem;
  font-weight: 700;
  color: var(--ac-white);
  background: var(--ac-gold);
  border-radius: 999px;
  text-decoration: none;
  box-shadow: var(--ac-shadow);
  transition: transform 0.2s ease, box-shadow 0.2s ease;
}

.twentytwentysix-content__event-card-cta-btn:hover {
  transform: translateY(-2px);
  box-shadow: 0 14px 40px rgba(0, 0, 0, 0.12);
}

.twentytwentysix-content__event-card-body {
  padding: 16px;
}

.twentytwentysix-content__event-card-meta-block {
  margin: 0 0 4px;
}

.twentytwentysix-content__event-card-meta-block--secondary {
  margin-top: 8px;
}

.twentytwentysix-content__event-card-meta {
  display: block;
  font-size: 0.9rem;
  color: var(--ac-muted);
  margin-top: 2px;
}

.twentytwentysix-content__event-card-meta:first-child {
  margin-top: 0;
}

.twentytwentysix-content__event-card-desc {
  font-size: 0.95rem;
  line-height: 1.5;
  color: var(--ac-text);
  margin: 0;
}

.twentytwentysix-content__event-card-cta {
  display: inline-block;
  margin-top: 10px;
  font-size: 0.95rem;
}

.twentytwentysix-content__empty-events {
  margin-bottom: 24px;
}

/* Resources: featured hero (mirrors donor Inspiration HeroPost) */
.twentytwentysix-content__featured-hero {
  padding-top: 0;
}

.twentytwentysix-content__featured-hero-inner {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 32px;
  align-items: center;
  text-decoration: none;
  color: inherit;
  background: var(--ac-white);
  border-radius: var(--ac-radius);
  box-shadow: var(--ac-shadow);
  overflow: hidden;
}

@media (max-width: 768px) {
  .twentytwentysix-content__featured-hero-inner {
    grid-template-columns: 1fr;
  }
}

.twentytwentysix-content__featured-hero-image-wrap {
  width: 100%;
  aspect-ratio: 16 / 10;
  overflow: hidden;
  background: var(--ac-light);
}

.twentytwentysix-content__featured-hero-image {
  display: block;
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.twentytwentysix-content__featured-hero-content {
  padding: 28px 24px 28px 0;
}

@media (max-width: 768px) {
  .twentytwentysix-content__featured-hero-content {
    padding: 24px;
  }
}

.twentytwentysix-content__featured-hero-kicker {
  margin-bottom: 8px;
}

.twentytwentysix-content__featured-hero-title {
  margin-bottom: 8px;
}

.twentytwentysix-content__featured-hero-byline {
  margin-bottom: 12px;
  font-size: 0.9rem;
}

.twentytwentysix-content__featured-hero-excerpt {
  margin-bottom: 16px;
}

.twentytwentysix-content__featured-hero-cta {
  display: inline-block;
  margin-top: 4px;
}

/* Resources: latest sidebar list */
.twentytwentysix-content__latest-sidebar-list {
  margin-top: 8px;
  margin-bottom: 0;
}

.twentytwentysix-content__latest-sidebar-item {
  padding: 0 0 10px;
  margin: 0;
}

.twentytwentysix-content__latest-sidebar-item::before {
  content: none;
}

.twentytwentysix-content__latest-sidebar-link {
  font-size: 0.95rem;
}
`, "",{"version":3,"sources":["webpack://./src/components/twentytwentysix/styles/TwentyTwentysixContent.css"],"names":[],"mappings":"AAAA;;EAEE;AACF;EACE,mBAAmB;EACnB,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;EACnB,kBAAkB;EAClB,sBAAsB;EACtB,kBAAkB;EAClB,mBAAmB;EACnB,mBAAmB;EACnB,4CAA4C;EAC5C,iBAAiB;EACjB,yCAAyC;;EAEzC,gBAAgB;EAChB,2BAA2B;EAC3B,qBAAqB;EACrB,yCAAyC;AAC3C;;AAEA;EACE;;;;;GAKC;EACD,uCAAuC;EACvC,mEAAmE;EACnE,cAAc;EACd,oBAAoB;AACtB;;AAEA;EACE;IACE,mEAAmE;EACrE;AACF;;AAEA;EACE;IACE,mEAAmE;EACrE;AACF;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,8BAA8B;EAC9B,sBAAsB;AACxB;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,yBAAyB;EACzB,qBAAqB;EACrB,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,mCAAmC;EACnC,gBAAgB;EAChB,iCAAiC;EACjC,qBAAqB;EACrB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,qBAAqB;EACrB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,UAAU;EACV,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,OAAO;EACP,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,4DAA4D;EAC5D,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,2BAA2B;EAC3B,+BAA+B;EAC/B,aAAa;EACb,4BAA4B;AAC9B;;AAEA;EACE,mCAAmC;EACnC,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,SAAS;EACT,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,qBAAqB;EACrB,kBAAkB;EAClB,oBAAoB;EACpB,0BAA0B;EAC1B,sBAAsB;EACtB,gBAAgB;EAChB,qBAAqB;EACrB,YAAY;EACZ,eAAe;EACf,eAAe;EACf,4BAA4B;EAC5B,qDAAqD;AACvD;;AAEA;EACE,2BAA2B;EAC3B,2CAA2C;AAC7C;;AAEA;EACE,uBAAuB;EACvB,qBAAqB;EACrB,gCAAgC;AAClC;;AAEA;EACE,qBAAqB;EACrB,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,eAAe;EACf,SAAS;AACX;;AAEA,4DAA4D;AAC5D;EACE,iBAAiB;EACjB,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,SAAO;EACP,gBAAgB;EAChB,kBAAkB;EAClB,gCAAgC;EAChC,oBAAoB;EACpB,eAAe;EACf,qBAAqB;EACrB,2BAA2B;AAC7B;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,+CAA+C;AACjD;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,oBAAoB;EACpB,kDAAkD;AACpD;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,iBAAiB;EACjB,oBAAoB;EACpB,iBAAiB;EACjB,gBAAgB;EAChB,qBAAqB;EACrB,gCAAgC;EAChC,qBAAqB;EACrB,uBAAuB;EACvB,eAAe;EACf,iDAAiD;AACnD;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,0BAA0B;EAC1B,sBAAsB;EACtB,4BAA4B;AAC9B;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;EACtB,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,oBAAoB;EACpB,kDAAkD;AACpD;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,4DAA4D;EAC5D,SAAS;AACX;;AAEA;EACE,2BAA2B;EAC3B,+BAA+B;EAC/B,4BAA4B;EAC5B,gBAAgB;EAChB,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,UAAU;EACV,SAAS;EACT,YAAY;EACZ,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,aAAa;EACb,cAAc;AAChB;;AAEA;EACE,iCAAiC;EACjC,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,mBAAmB;EACnB,gBAAgB;EAChB,2BAA2B;AAC7B;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,WAAW;EACX,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,wBAAwB;EACxB,yBAAyB;EACzB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,iBAAiB;EACjB,8BAA8B;AAChC;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,WAAW;EACX,YAAY;EACZ,2BAA2B;AAC7B;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;EACrB,kBAAkB;EAClB,sBAAsB;EACtB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,QAAQ;EACR,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,iBAAiB;EACjB,oBAAoB;EACpB,2BAA2B;EAC3B,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,SAAS;EACT,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,sBAAsB;AACxB;;AAEA,2DAA2D;AAC3D;EACE,eAAe;EACf,QAAQ;EACR,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,8BAA8B;EAC9B,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,gBAAgB;EAChB,8BAA8B;EAC9B,gBAAgB;EAChB,2BAA2B;EAC3B,+BAA+B;EAC/B,4BAA4B;EAC5B,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,WAAW;EACX,YAAY;EACZ,UAAU;EACV,iBAAiB;EACjB,cAAc;EACd,sBAAsB;EACtB,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;EACrB,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE;IACE,0BAA0B;EAC5B;AACF;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,sBAAsB;EACtB,eAAe;EACf,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,mCAAmC;EACnC,gBAAgB;EAChB,iBAAiB;EACjB,qBAAqB;EACrB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,qBAAqB;EACrB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,SAAS;EACT,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,QAAQ;AACV;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,WAAW;EACX,gBAAgB;EAChB,iBAAiB;EACjB,2BAA2B;EAC3B,+BAA+B;EAC/B,gBAAgB;AAClB;;AAEA;EACE;IACE,oBAAoB;IACpB,eAAe;EACjB;AACF;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,eAAe;EACf,SAAS;EACT,gBAAgB;EAChB,iBAAiB;EACjB,qCAAqC;AACvC;;AAEA;EACE,qCAAqC;EACrC,gCAAgC;EAChC,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,2BAA2B;EAC3B,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,sBAAsB;EACtB,eAAe;AACjB;;AAEA,2GAA2G;AAC3G;EACE,aAAa;EACb,gCAAgC;EAChC,SAAS;EACT,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE;IACE,0BAA0B;EAC5B;AACF;;AAEA;EACE,gBAAgB;EAChB,SAAS;EACT,sBAAsB;EACtB,8BAA8B;EAC9B,gBAAgB;EAChB,2BAA2B;EAC3B,+BAA+B;EAC/B,aAAa;EACb,4BAA4B;AAC9B;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;EACtB,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,UAAU;EACV,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,SAAS;AACX;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,cAAc;EACd,WAAW;EACX,gBAAgB;EAChB,eAAe;EACf,kBAAkB;EAClB,qBAAqB;EACrB,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,wCAAwC;EACxC,2BAA2B;AAC7B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,qCAAqC;AACvC;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,qCAAqC;AACvC;;AAEA;EACE,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,YAAY;AACd;;AAEA,0DAA0D;AAC1D;EACE,oBAAoB;AACtB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;EACtB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,aAAa;AACf;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,SAAS;AACX;;AAEA,oDAAoD;AACpD;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,WAAW;EACX,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,qBAAqB;EACrB,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;EACjB,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,cAAc;EACd,eAAe;EACf,iBAAiB;EACjB,qBAAqB;AACvB;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,SAAS;AACX;;AAEA,sFAAsF;AACtF;EACE,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,4DAA4D;EAC5D,SAAS;AACX;;AAEA,kGAAkG;AAClG;EACE,kBAAkB;EAClB,2BAA2B;EAC3B,+BAA+B;EAC/B,4BAA4B;EAC5B,iBAAiB;EACjB,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,gBAAgB;EAChB,+BAA+B;AACjC;;AAEA,yDAAyD;AACzD;EACE,kBAAkB;EAClB,SAAS;EACT,UAAU;EACV,UAAU;EACV,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,qBAAqB;EACrB,2BAA2B;EAC3B,qBAAqB;EACrB,mBAAmB;EACnB,4BAA4B;EAC5B,gCAAgC;AAClC;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,2BAA2B;AAC7B;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,wBAAwB;EACxB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,WAAW;EACX,YAAY;EACZ,2BAA2B;AAC7B;;AAEA,oEAAoE;AACpE;EACE,kBAAkB;EAClB,QAAQ;EACR,aAAa;EACb,sBAAsB;EACtB,yBAAyB;EACzB,uBAAuB;EACvB,oGAAoG;EACpG,oBAAoB;AACtB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,sBAAsB;EACtB,iBAAiB;EACjB,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,sBAAsB;EACtB,0BAA0B;EAC1B,oBAAoB;AACtB;;AAEA;EACE,mCAAmC;EACnC,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,gBAAgB;EAChB,yCAAyC;AAC3C;;AAEA;EACE,sBAAsB;EACtB,qBAAqB;EACrB,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,0BAA0B;EAC1B,oBAAoB;EACpB,qBAAqB;EACrB,4BAA4B;EAC5B,qDAAqD;AACvD;;AAEA;EACE,2BAA2B;EAC3B,2CAA2C;AAC7C;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,sBAAsB;EACtB,eAAe;AACjB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,qBAAqB;EACrB,SAAS;AACX;;AAEA;EACE,qBAAqB;EACrB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA,kEAAkE;AAClE;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;EACT,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;EACd,2BAA2B;EAC3B,+BAA+B;EAC/B,4BAA4B;EAC5B,gBAAgB;AAClB;;AAEA;EACE;IACE,0BAA0B;EAC5B;AACF;;AAEA;EACE,WAAW;EACX,qBAAqB;EACrB,gBAAgB;EAChB,2BAA2B;AAC7B;;AAEA;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE;IACE,aAAa;EACf;AACF;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,eAAe;AACjB;;AAEA,mCAAmC;AACnC;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,SAAS;AACX;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,kBAAkB;AACpB","sourcesContent":["/**\n * Shared content pages (Resources, Events, Podcasts, etc.) — matches homepage/collective.\n */\n.twentytwentysix-content {\n  --ac-cream: #efe4d3;\n  --ac-light: #f5f3f1;\n  --ac-teal: #6f9f9a;\n  --ac-coral: #df775f;\n  --ac-gold: #d8b04e;\n  --ac-charcoal: #4b4450;\n  --ac-text: #433d43;\n  --ac-muted: #6b666b;\n  --ac-white: #ffffff;\n  --ac-shadow: 0 10px 30px rgba(0, 0, 0, 0.08);\n  --ac-radius: 20px;\n  --ac-font-display: \"fabulosa\", sans-serif;\n\n  min-height: 50vh;\n  background: var(--ac-light);\n  color: var(--ac-text);\n  font-family: Arial, Helvetica, sans-serif;\n}\n\n.twentytwentysix-content__container {\n  /* Responsive content container\n     - Desktop: cap content width at 1080px with generous gutters\n     - Tablet: slightly tighter gutters\n     - Mobile: full-width with safe side padding\n     This is the standard content-width system for twentytwentysix pages.\n  */\n  --twentytwentysix-container-max: 1080px;\n  width: min(var(--twentytwentysix-container-max), calc(100% - 48px));\n  margin: 0 auto;\n  padding: 48px 0 64px;\n}\n\n@media (max-width: 900px) {\n  .twentytwentysix-content__container {\n    width: min(var(--twentytwentysix-container-max), calc(100% - 32px));\n  }\n}\n\n@media (max-width: 600px) {\n  .twentytwentysix-content__container {\n    width: min(var(--twentytwentysix-container-max), calc(100% - 24px));\n  }\n}\n\n.twentytwentysix-content__section {\n  padding: 40px 0;\n}\n\n.twentytwentysix-content__section--cream {\n  background: var(--ac-cream);\n}\n\n.twentytwentysix-content__section--charcoal {\n  background: var(--ac-charcoal);\n  color: var(--ac-white);\n}\n\n.twentytwentysix-content__section--charcoal .twentytwentysix-content__copy {\n  color: rgba(255, 255, 255, 0.9);\n}\n\n.twentytwentysix-content__eyebrow {\n  font-size: 0.9rem;\n  font-weight: 700;\n  text-transform: uppercase;\n  letter-spacing: 0.2em;\n  color: var(--ac-muted);\n  margin: 0 0 12px;\n}\n\n.twentytwentysix-content__title {\n  font-family: var(--ac-font-display);\n  font-weight: 400;\n  font-size: clamp(2rem, 4vw, 3rem);\n  color: var(--ac-teal);\n  margin: 0 0 16px;\n  line-height: 1.1;\n}\n\n.twentytwentysix-content__section--charcoal .twentytwentysix-content__title {\n  color: var(--ac-white);\n}\n\n.twentytwentysix-content__copy {\n  font-size: 1.05rem;\n  line-height: 1.65;\n  color: var(--ac-text);\n  margin: 0 0 16px;\n  max-width: 720px;\n}\n\n.twentytwentysix-content__subtitle {\n  font-size: 1.1rem;\n  font-weight: 700;\n  text-transform: uppercase;\n  letter-spacing: 0.12em;\n  margin: 28px 0 12px;\n}\n\n.twentytwentysix-content__list {\n  list-style: none;\n  padding: 0;\n  margin: 0 0 24px;\n}\n\n.twentytwentysix-content__list li {\n  position: relative;\n  padding-left: 24px;\n  margin: 10px 0;\n  line-height: 1.5;\n}\n\n.twentytwentysix-content__list li::before {\n  content: \"•\";\n  position: absolute;\n  left: 0;\n  color: var(--ac-teal);\n  font-weight: 700;\n}\n\n.twentytwentysix-content__card-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));\n  gap: 24px;\n  margin-top: 24px;\n}\n\n.twentytwentysix-content__card {\n  background: var(--ac-white);\n  border-radius: var(--ac-radius);\n  padding: 24px;\n  box-shadow: var(--ac-shadow);\n}\n\n.twentytwentysix-content__card h4 {\n  font-family: var(--ac-font-display);\n  font-weight: 400;\n  font-size: 1.4rem;\n  margin: 0 0 10px;\n  color: var(--ac-teal);\n}\n\n.twentytwentysix-content__card p {\n  margin: 0;\n  font-size: 0.98rem;\n  line-height: 1.5;\n  color: var(--ac-muted);\n}\n\n.twentytwentysix-content__pill {\n  display: inline-block;\n  padding: 12px 24px;\n  border-radius: 999px;\n  background: var(--ac-gold);\n  color: var(--ac-white);\n  font-weight: 700;\n  text-decoration: none;\n  border: none;\n  cursor: pointer;\n  font-size: 1rem;\n  box-shadow: var(--ac-shadow);\n  transition: transform 0.2s ease, box-shadow 0.2s ease;\n}\n\n.twentytwentysix-content__pill:hover {\n  transform: translateY(-2px);\n  box-shadow: 0 14px 40px rgba(0, 0, 0, 0.12);\n}\n\n.twentytwentysix-content__pill--outline {\n  background: transparent;\n  color: var(--ac-teal);\n  border: 2px solid var(--ac-teal);\n}\n\n.twentytwentysix-content__link {\n  color: var(--ac-teal);\n  font-weight: 600;\n  text-decoration: none;\n}\n\n.twentytwentysix-content__link:hover {\n  text-decoration: underline;\n}\n\n.twentytwentysix-content__cta-row {\n  margin-top: 28px;\n  display: flex;\n  flex-wrap: wrap;\n  gap: 14px;\n}\n\n/* Filter bar: search and filter controls (Events, M List) */\n.twentytwentysix-content__filter-bar {\n  padding-top: 16px;\n  padding-bottom: 24px;\n}\n\n.twentytwentysix-content__search-form {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  gap: 12px;\n}\n\n.twentytwentysix-content__filter-input {\n  flex: 1;\n  min-width: 200px;\n  padding: 10px 16px;\n  border: 2px solid var(--ac-teal);\n  border-radius: 999px;\n  font-size: 1rem;\n  color: var(--ac-text);\n  background: var(--ac-white);\n}\n\n.twentytwentysix-content__filter-input::placeholder {\n  color: var(--ac-muted);\n}\n\n.twentytwentysix-content__filter-input:focus {\n  outline: none;\n  box-shadow: 0 0 0 3px rgba(111, 159, 154, 0.25);\n}\n\n.twentytwentysix-content__pill--small {\n  padding: 8px 18px;\n  font-size: 0.95rem;\n}\n\n.twentytwentysix-content__event-item {\n  margin-bottom: 16px;\n  padding-bottom: 16px;\n  border-bottom: 1px solid var(--ac-border, #e0e0e0);\n}\n\n.twentytwentysix-content__event-item:last-child {\n  border-bottom: none;\n}\n\n.twentytwentysix-content__event-meta {\n  display: block;\n  font-size: 0.9rem;\n  color: var(--ac-muted);\n}\n\n.twentytwentysix-content__event-desc {\n  margin: 8px 0 0;\n  font-size: 0.95rem;\n}\n\n.twentytwentysix-content__filter-pills {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 8px;\n  margin-bottom: 16px;\n}\n\n.twentytwentysix-content__filter-pill {\n  display: inline-block;\n  padding: 6px 14px;\n  border-radius: 999px;\n  font-size: 0.9rem;\n  font-weight: 600;\n  text-decoration: none;\n  border: 2px solid var(--ac-teal);\n  color: var(--ac-teal);\n  background: transparent;\n  cursor: pointer;\n  transition: background 0.2s ease, color 0.2s ease;\n}\n\n.twentytwentysix-content__filter-pill:hover {\n  background: rgba(111, 159, 154, 0.1);\n}\n\n.twentytwentysix-content__filter-pill--active {\n  background: var(--ac-teal);\n  color: var(--ac-white);\n  border-color: var(--ac-teal);\n}\n\n.twentytwentysix-content__filter-pills-wrap {\n  margin-top: 12px;\n}\n\n.twentytwentysix-content__filter-label {\n  display: block;\n  font-size: 0.85rem;\n  font-weight: 700;\n  text-transform: uppercase;\n  letter-spacing: 0.08em;\n  color: var(--ac-muted);\n  margin-bottom: 8px;\n}\n\n.twentytwentysix-content__list--no-bullets li::before {\n  content: none;\n}\n\n.twentytwentysix-content__list--no-bullets {\n  padding-left: 0;\n}\n\n.twentytwentysix-content__listing-item {\n  margin-bottom: 12px;\n  padding-bottom: 12px;\n  border-bottom: 1px solid var(--ac-border, #e0e0e0);\n}\n\n.twentytwentysix-content__listing-item:last-child {\n  border-bottom: none;\n}\n\n.twentytwentysix-content__listing-desc {\n  display: block;\n  color: var(--ac-muted);\n  font-size: 0.95rem;\n  margin: 6px 0 0;\n}\n\n.twentytwentysix-content__listing-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));\n  gap: 24px;\n}\n\n.twentytwentysix-content__listing-card {\n  background: var(--ac-white);\n  border-radius: var(--ac-radius);\n  box-shadow: var(--ac-shadow);\n  overflow: hidden;\n  margin-bottom: 0;\n  padding-bottom: 0;\n  border-bottom: none;\n}\n\n.twentytwentysix-content__listing-card-inner {\n  display: block;\n  width: 100%;\n  padding: 0;\n  margin: 0;\n  border: none;\n  background: none;\n  cursor: pointer;\n  text-align: left;\n  font: inherit;\n  color: inherit;\n}\n\n.twentytwentysix-content__listing-card-inner:focus {\n  outline: 2px solid var(--ac-teal);\n  outline-offset: 2px;\n}\n\n.twentytwentysix-content__listing-image-wrap {\n  position: relative;\n  width: 100%;\n  aspect-ratio: 1 / 1;\n  overflow: hidden;\n  background: var(--ac-light);\n}\n\n.twentytwentysix-content__listing-image-media {\n  position: absolute;\n  inset: 0;\n  width: 100%;\n  height: 100%;\n  overflow: hidden;\n}\n\n.twentytwentysix-content__listing-image {\n  display: block;\n  width: calc(100% + 48px);\n  height: calc(100% + 48px);\n  max-width: none;\n  max-height: none;\n  margin-top: -24px;\n  margin-left: -40px;\n  object-fit: cover;\n  object-position: center center;\n}\n\n.twentytwentysix-content__listing-image-placeholder {\n  position: absolute;\n  inset: 0;\n  width: 100%;\n  height: 100%;\n  background: var(--ac-light);\n}\n\n.twentytwentysix-content__listing-body {\n  padding: 16px;\n}\n\n.twentytwentysix-content__listing-name {\n  display: block;\n  font-size: 1.1rem;\n  color: var(--ac-teal);\n}\n\n.twentytwentysix-content__listing-hearts {\n  display: inline-block;\n  font-size: 0.85rem;\n  color: var(--ac-coral);\n  margin-top: 4px;\n}\n\n.twentytwentysix-content__listing-tags {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 6px;\n  margin-top: 10px;\n}\n\n.twentytwentysix-content__listing-tag {\n  font-size: 0.8rem;\n  padding: 4px 10px;\n  border-radius: 999px;\n  background: var(--ac-light);\n  color: var(--ac-muted);\n}\n\n.twentytwentysix-content__listing-meta {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 12px;\n  margin-top: 10px;\n  font-size: 0.9rem;\n}\n\n.twentytwentysix-content__listing-phone {\n  color: var(--ac-muted);\n}\n\n/* Listing detail modal — twentytwentysix design language */\n.twentytwentysix-content__listing-detail-overlay {\n  position: fixed;\n  inset: 0;\n  z-index: 10000;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 24px;\n  background: rgba(0, 0, 0, 0.4);\n  overflow-y: auto;\n}\n\n.twentytwentysix-content__listing-detail-modal {\n  position: relative;\n  width: 100%;\n  max-width: 720px;\n  max-height: calc(100vh - 48px);\n  overflow-y: auto;\n  background: var(--ac-white);\n  border-radius: var(--ac-radius);\n  box-shadow: var(--ac-shadow);\n  padding: 28px 24px 24px;\n}\n\n.twentytwentysix-content__listing-detail-close {\n  position: absolute;\n  top: 12px;\n  right: 12px;\n  width: 36px;\n  height: 36px;\n  padding: 0;\n  font-size: 1.5rem;\n  line-height: 1;\n  color: var(--ac-muted);\n  background: none;\n  border: none;\n  cursor: pointer;\n  border-radius: 50%;\n}\n\n.twentytwentysix-content__listing-detail-close:hover {\n  color: var(--ac-text);\n  background: var(--ac-light);\n}\n\n.twentytwentysix-content__listing-detail-grid {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 28px;\n  align-items: start;\n}\n\n@media (max-width: 640px) {\n  .twentytwentysix-content__listing-detail-grid {\n    grid-template-columns: 1fr;\n  }\n}\n\n.twentytwentysix-content__listing-detail-content {\n  min-width: 0;\n}\n\n.twentytwentysix-content__listing-detail-meta {\n  font-size: 0.85rem;\n  color: var(--ac-muted);\n  margin: 0 0 8px;\n  text-transform: uppercase;\n  letter-spacing: 0.06em;\n}\n\n.twentytwentysix-content__listing-detail-title {\n  font-family: var(--ac-font-display);\n  font-weight: 400;\n  font-size: 1.6rem;\n  color: var(--ac-teal);\n  margin: 0 0 10px;\n  line-height: 1.2;\n}\n\n.twentytwentysix-content__listing-detail-subhead {\n  font-size: 1rem;\n  color: var(--ac-text);\n  margin: 0 0 14px;\n  line-height: 1.45;\n}\n\n.twentytwentysix-content__listing-detail-body {\n  font-size: 0.98rem;\n  line-height: 1.6;\n  color: var(--ac-text);\n  margin: 0 0 16px;\n}\n\n.twentytwentysix-content__listing-detail-body p {\n  margin: 0 0 10px;\n}\n\n.twentytwentysix-content__listing-detail-body p:last-child {\n  margin-bottom: 0;\n}\n\n.twentytwentysix-content__listing-detail-links {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 12px;\n  margin-bottom: 14px;\n  font-size: 0.9rem;\n}\n\n.twentytwentysix-content__listing-detail-badges {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 8px;\n}\n\n.twentytwentysix-content__listing-detail-image-wrap {\n  position: relative;\n  aspect-ratio: 1;\n  width: 100%;\n  max-width: 320px;\n  justify-self: end;\n  background: var(--ac-light);\n  border-radius: var(--ac-radius);\n  overflow: hidden;\n}\n\n@media (max-width: 640px) {\n  .twentytwentysix-content__listing-detail-image-wrap {\n    justify-self: center;\n    max-width: 100%;\n  }\n}\n\n.twentytwentysix-content__listing-detail-image {\n  position: absolute;\n  inset: 0;\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n  object-position: center;\n  display: block;\n}\n\n.twentytwentysix-content__listing-detail-image-placeholder {\n  position: absolute;\n  inset: 0;\n  background: var(--ac-light);\n}\n\n.twentytwentysix-content__listing-detail-actions {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 12px;\n  margin-top: 24px;\n  padding-top: 20px;\n  border-top: 1px solid var(--ac-light);\n}\n\n.twentytwentysix-content__api-notice {\n  background: rgba(111, 159, 154, 0.12);\n  border: 1px solid var(--ac-teal);\n  border-radius: 12px;\n  padding: 16px 20px;\n}\n\n.twentytwentysix-content__api-notice-text code {\n  background: var(--ac-white);\n  padding: 2px 6px;\n  border-radius: 4px;\n  font-size: 0.9em;\n}\n\n.twentytwentysix-content__empty-listings {\n  margin-bottom: 24px;\n}\n\n.twentytwentysix-content__copy--muted {\n  font-size: 0.95rem;\n  color: var(--ac-muted);\n  margin-top: 8px;\n}\n\n/* M List: two-column layout (sidebar + main) — layout from legacy TheMList, styling from twentytwentysix */\n.twentytwentysix-content__mlist-layout {\n  display: grid;\n  grid-template-columns: 260px 1fr;\n  gap: 40px;\n  align-items: start;\n  margin-top: 32px;\n}\n\n.twentytwentysix-content__mlist-sidebar-col {\n  min-width: 0;\n}\n\n@media (max-width: 768px) {\n  .twentytwentysix-content__mlist-layout {\n    grid-template-columns: 1fr;\n  }\n}\n\n.twentytwentysix-content__mlist-sidebar {\n  position: sticky;\n  top: 24px;\n  align-self: flex-start;\n  max-height: calc(100vh - 48px);\n  overflow-y: auto;\n  background: var(--ac-white);\n  border-radius: var(--ac-radius);\n  padding: 24px;\n  box-shadow: var(--ac-shadow);\n}\n\n.twentytwentysix-content__mlist-sidebar-title {\n  font-size: 0.85rem;\n  font-weight: 700;\n  text-transform: uppercase;\n  letter-spacing: 0.12em;\n  color: var(--ac-muted);\n  margin: 0 0 14px;\n}\n\n.twentytwentysix-content__mlist-sidebar-nav {\n  list-style: none;\n  padding: 0;\n  margin: 0 0 20px;\n}\n\n.twentytwentysix-content__mlist-sidebar-nav li {\n  padding-left: 0;\n  margin: 0;\n}\n\n.twentytwentysix-content__mlist-sidebar-nav li::before {\n  content: none;\n}\n\n.twentytwentysix-content__mlist-sidebar-nav button {\n  display: block;\n  width: 100%;\n  text-align: left;\n  padding: 10px 0;\n  font-size: 0.95rem;\n  color: var(--ac-text);\n  background: none;\n  border: none;\n  cursor: pointer;\n  border-bottom: 1px solid var(--ac-light);\n  transition: color 0.2s ease;\n}\n\n.twentytwentysix-content__mlist-sidebar-nav button:last-child {\n  border-bottom: none;\n}\n\n.twentytwentysix-content__mlist-sidebar-nav button:hover {\n  color: var(--ac-teal);\n}\n\n.twentytwentysix-content__mlist-sidebar-nav button.twentytwentysix-content__mlist-sidebar-nav--active {\n  color: var(--ac-teal);\n  font-weight: 700;\n}\n\n.twentytwentysix-content__mlist-sidebar-featured {\n  margin: 20px 0;\n  padding-top: 20px;\n  border-top: 1px solid var(--ac-light);\n}\n\n.twentytwentysix-content__mlist-sidebar-cta {\n  margin-top: 24px;\n  padding-top: 24px;\n  border-top: 1px solid var(--ac-light);\n}\n\n.twentytwentysix-content__mlist-sidebar-cta .twentytwentysix-content__copy {\n  margin-bottom: 14px;\n  max-width: none;\n}\n\n.twentytwentysix-content__mlist-main {\n  min-width: 0;\n}\n\n/* M List: top facet groups (value, badge, philanthropy) */\n.twentytwentysix-content__mlist-top-filters {\n  padding-bottom: 24px;\n}\n\n.twentytwentysix-content__mlist-clear-filters {\n  margin-left: 8px;\n}\n\n.twentytwentysix-content__mlist-facets-row {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 24px 32px;\n  margin-top: 20px;\n}\n\n.twentytwentysix-content__mlist-facet-group {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.twentytwentysix-content__mlist-facet-group-title {\n  font-size: 0.85rem;\n  font-weight: 700;\n  text-transform: uppercase;\n  letter-spacing: 0.08em;\n  color: var(--ac-muted);\n}\n\n.twentytwentysix-content__mlist-facet-options {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 8px 16px;\n}\n\n.twentytwentysix-content__mlist-facet-option {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  cursor: pointer;\n  font-size: 0.95rem;\n  color: var(--ac-text);\n}\n\n.twentytwentysix-content__mlist-facet-option input {\n  margin: 0;\n}\n\n/* M List: left sidebar expandable category groups */\n.twentytwentysix-content__mlist-sidebar-groups {\n  margin-bottom: 20px;\n}\n\n.twentytwentysix-content__mlist-sidebar-group {\n  margin-bottom: 4px;\n}\n\n.twentytwentysix-content__mlist-sidebar-group-head {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  width: 100%;\n  padding: 8px 0;\n  font-size: 0.95rem;\n  font-weight: 600;\n  color: var(--ac-text);\n  background: none;\n  border: none;\n  cursor: pointer;\n  text-align: left;\n}\n\n.twentytwentysix-content__mlist-sidebar-group-head:hover {\n  color: var(--ac-teal);\n}\n\n.twentytwentysix-content__mlist-sidebar-group-caret {\n  font-size: 0.7rem;\n  color: var(--ac-muted);\n}\n\n.twentytwentysix-content__mlist-sidebar-group-body {\n  padding-left: 14px;\n  margin-bottom: 8px;\n}\n\n.twentytwentysix-content__mlist-sidebar-check {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  padding: 6px 0;\n  cursor: pointer;\n  font-size: 0.9rem;\n  color: var(--ac-text);\n}\n\n.twentytwentysix-content__mlist-sidebar-check input {\n  margin: 0;\n}\n\n.twentytwentysix-content__mlist-sidebar-check:hover {\n  color: var(--ac-teal);\n}\n\n.twentytwentysix-content__mlist-sidebar-clear {\n  margin-bottom: 12px;\n}\n\n.twentytwentysix-content__mlist-sidebar-clear-categories {\n  margin-bottom: 12px;\n}\n\n.twentytwentysix-content__mlist-sidebar-facet-group {\n  margin-bottom: 20px;\n}\n\n.twentytwentysix-content__mlist-sidebar-facet-group .twentytwentysix-content__mlist-sidebar-title {\n  margin-bottom: 10px;\n}\n\n.twentytwentysix-content__mlist-sidebar-facet-options {\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n}\n\n.twentytwentysix-content__mlist-results-header {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  gap: 16px;\n  margin-bottom: 16px;\n}\n\n.twentytwentysix-content__mlist-featured-toggle {\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  cursor: pointer;\n  font-size: 0.95rem;\n  color: var(--ac-text);\n}\n\n.twentytwentysix-content__mlist-featured-toggle input {\n  margin: 0;\n}\n\n/* Events page: same layout rhythm as M List (no sidebar), same card/filter language */\n.twentytwentysix-content__events-layout {\n  margin-top: 32px;\n}\n\n.twentytwentysix-content__events-top-filters {\n  padding-bottom: 24px;\n}\n\n.twentytwentysix-content__events-clear-filters {\n  margin-left: 8px;\n}\n\n.twentytwentysix-content__events-results-header {\n  margin-bottom: 16px;\n}\n\n.twentytwentysix-content__event-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));\n  gap: 24px;\n}\n\n/* Event card: date tab overlapping top + square image-led card (title/CTA on image, copy below) */\n.twentytwentysix-content__event-card {\n  position: relative;\n  background: var(--ac-white);\n  border-radius: var(--ac-radius);\n  box-shadow: var(--ac-shadow);\n  overflow: visible;\n  margin-bottom: 0;\n  padding-bottom: 0;\n  border-bottom: none;\n}\n\n.twentytwentysix-content__event-card-inner {\n  display: block;\n  width: 100%;\n  overflow: hidden;\n  border-radius: var(--ac-radius);\n}\n\n/* Date tab: overlaps top edge of card, month above day */\n.twentytwentysix-content__event-date-tab {\n  position: absolute;\n  top: -6px;\n  left: 16px;\n  z-index: 2;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  min-width: 52px;\n  padding: 6px 10px 8px;\n  background: var(--ac-white);\n  color: var(--ac-teal);\n  border-radius: 10px;\n  box-shadow: var(--ac-shadow);\n  border: 2px solid var(--ac-teal);\n}\n\n.twentytwentysix-content__event-date-tab-month {\n  display: block;\n  font-size: 0.7rem;\n  font-weight: 700;\n  letter-spacing: 0.08em;\n  line-height: 1.2;\n}\n\n.twentytwentysix-content__event-date-tab-day {\n  display: block;\n  font-size: 1.35rem;\n  font-weight: 700;\n  line-height: 1.1;\n}\n\n.twentytwentysix-content__event-image-wrap {\n  position: relative;\n  width: 100%;\n  aspect-ratio: 1;\n  overflow: hidden;\n  background: var(--ac-light);\n}\n\n.twentytwentysix-content__event-image {\n  position: absolute;\n  inset: 0;\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n  object-position: 58% 50%;\n  display: block;\n}\n\n.twentytwentysix-content__event-image-placeholder {\n  position: absolute;\n  inset: 0;\n  width: 100%;\n  height: 100%;\n  background: var(--ac-light);\n}\n\n/* Overlay on image: gradient + title, event type pill, CTA button */\n.twentytwentysix-content__event-image-overlay {\n  position: absolute;\n  inset: 0;\n  display: flex;\n  flex-direction: column;\n  justify-content: flex-end;\n  padding: 20px 16px 16px;\n  background: linear-gradient(to top, rgba(0, 0, 0, 0.65) 0%, rgba(0, 0, 0, 0.2) 45%, transparent 70%);\n  pointer-events: none;\n}\n\n.twentytwentysix-content__event-image-overlay .twentytwentysix-content__event-card-cta-btn {\n  pointer-events: auto;\n}\n\n.twentytwentysix-content__event-type-pill {\n  align-self: flex-start;\n  padding: 4px 10px;\n  margin-bottom: 8px;\n  font-size: 0.75rem;\n  font-weight: 700;\n  letter-spacing: 0.06em;\n  text-transform: uppercase;\n  color: var(--ac-white);\n  background: var(--ac-teal);\n  border-radius: 999px;\n}\n\n.twentytwentysix-content__event-card-title {\n  font-family: var(--ac-font-display);\n  font-weight: 400;\n  font-size: 1.25rem;\n  line-height: 1.2;\n  color: var(--ac-white);\n  margin: 0 0 10px;\n  text-shadow: 0 1px 3px rgba(0, 0, 0, 0.4);\n}\n\n.twentytwentysix-content__event-card-cta-btn {\n  align-self: flex-start;\n  display: inline-block;\n  padding: 10px 20px;\n  font-size: 0.95rem;\n  font-weight: 700;\n  color: var(--ac-white);\n  background: var(--ac-gold);\n  border-radius: 999px;\n  text-decoration: none;\n  box-shadow: var(--ac-shadow);\n  transition: transform 0.2s ease, box-shadow 0.2s ease;\n}\n\n.twentytwentysix-content__event-card-cta-btn:hover {\n  transform: translateY(-2px);\n  box-shadow: 0 14px 40px rgba(0, 0, 0, 0.12);\n}\n\n.twentytwentysix-content__event-card-body {\n  padding: 16px;\n}\n\n.twentytwentysix-content__event-card-meta-block {\n  margin: 0 0 4px;\n}\n\n.twentytwentysix-content__event-card-meta-block--secondary {\n  margin-top: 8px;\n}\n\n.twentytwentysix-content__event-card-meta {\n  display: block;\n  font-size: 0.9rem;\n  color: var(--ac-muted);\n  margin-top: 2px;\n}\n\n.twentytwentysix-content__event-card-meta:first-child {\n  margin-top: 0;\n}\n\n.twentytwentysix-content__event-card-desc {\n  font-size: 0.95rem;\n  line-height: 1.5;\n  color: var(--ac-text);\n  margin: 0;\n}\n\n.twentytwentysix-content__event-card-cta {\n  display: inline-block;\n  margin-top: 10px;\n  font-size: 0.95rem;\n}\n\n.twentytwentysix-content__empty-events {\n  margin-bottom: 24px;\n}\n\n/* Resources: featured hero (mirrors donor Inspiration HeroPost) */\n.twentytwentysix-content__featured-hero {\n  padding-top: 0;\n}\n\n.twentytwentysix-content__featured-hero-inner {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 32px;\n  align-items: center;\n  text-decoration: none;\n  color: inherit;\n  background: var(--ac-white);\n  border-radius: var(--ac-radius);\n  box-shadow: var(--ac-shadow);\n  overflow: hidden;\n}\n\n@media (max-width: 768px) {\n  .twentytwentysix-content__featured-hero-inner {\n    grid-template-columns: 1fr;\n  }\n}\n\n.twentytwentysix-content__featured-hero-image-wrap {\n  width: 100%;\n  aspect-ratio: 16 / 10;\n  overflow: hidden;\n  background: var(--ac-light);\n}\n\n.twentytwentysix-content__featured-hero-image {\n  display: block;\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n}\n\n.twentytwentysix-content__featured-hero-content {\n  padding: 28px 24px 28px 0;\n}\n\n@media (max-width: 768px) {\n  .twentytwentysix-content__featured-hero-content {\n    padding: 24px;\n  }\n}\n\n.twentytwentysix-content__featured-hero-kicker {\n  margin-bottom: 8px;\n}\n\n.twentytwentysix-content__featured-hero-title {\n  margin-bottom: 8px;\n}\n\n.twentytwentysix-content__featured-hero-byline {\n  margin-bottom: 12px;\n  font-size: 0.9rem;\n}\n\n.twentytwentysix-content__featured-hero-excerpt {\n  margin-bottom: 16px;\n}\n\n.twentytwentysix-content__featured-hero-cta {\n  display: inline-block;\n  margin-top: 4px;\n}\n\n/* Resources: latest sidebar list */\n.twentytwentysix-content__latest-sidebar-list {\n  margin-top: 8px;\n  margin-bottom: 0;\n}\n\n.twentytwentysix-content__latest-sidebar-item {\n  padding: 0 0 10px;\n  margin: 0;\n}\n\n.twentytwentysix-content__latest-sidebar-item::before {\n  content: none;\n}\n\n.twentytwentysix-content__latest-sidebar-link {\n  font-size: 0.95rem;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
